<template>
    <div class="library-qa-status-filter">
        <CollapsibleWidget>
            <template #name>Production Status</template>

            <RadioGroup :model-value="qaStatusFilter">
                <Radio
                    v-for="filter in BannerQaStatusFilter"
                    :key="filter"
                    :label="filter"
                    @click.stop.prevent="setQaStatusFilter(filter)"
                >
                    <div
                        v-if="filter !== BannerQaStatusFilter.All"
                        class="library-qa-status-filter__status-dot-wrapper"
                    >
                        <QaStatusDot :status="filter" />
                    </div>
                    {{ BannerQaStatusFilterLabel[filter] }}
                </Radio>
            </RadioGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts">
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import QaStatusDot from "@/components/Qa/QaStatusDot.vue";
import { BannerQaStatusFilter, BannerQaStatusFilterLabel } from "@/enums/banners";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";

export default {
    components: {
        CollapsibleWidget,
        QaStatusDot
    },

    data() {
        return {
            BannerQaStatusFilter,
            BannerQaStatusFilterLabel
        };
    },

    computed: {
        qaStatusFilter: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.statusFilter];
            },
            set(value: (typeof BannerQaStatusFilter)[keyof typeof BannerQaStatusFilter]) {
                this.$store.dispatch(DeliverableLibraryAction.UpdateStatusFilter, value);
            }
        }
    },

    methods: {
        setQaStatusFilter(qaStatus: (typeof BannerQaStatusFilter)[keyof typeof BannerQaStatusFilter]) {
            this.qaStatusFilter = qaStatus;
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-qa-status-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}

.library-qa-status-filter__status-dot-wrapper {
    display: inline-block;
    padding: 0 0 0 $spacing-smaller;
}
</style>
